module.exports = __webpack_public_path__ + "static/media/darko.2bae3eb1.jpg";